import { css } from "@stubhub/broadway-foundation/css";

export const soldOutWrapperStyle = css({ cursor: "pointer" });
